/*
 * patient-referral (schema)
 */
import { boolean, date, text, timestamp, uuid, varchar } from "drizzle-orm/pg-core"
import { schema } from "../constants"
import { patients } from "../patient/patient.schema"
import { referrals } from "../referral/referral.schema"
import { users } from "../user/user.schema"

export const patientReferrals = schema.table("patient_referrals", {
	id: uuid("id").primaryKey().notNull().defaultRandom(),

	// --- Relations ---
	patientId: uuid("patient_id").notNull().references(() => patients.id, { onDelete: "cascade" }),
	referralId: uuid("referral_id").notNull().references(() => referrals.id, { onDelete: "restrict" }),

	// --- General ---
	direction: varchar("direction", { length: 32 }).notNull(), // incoming | outgoing
	referralDate: date("referral_date"),
	notes: text("notes"),

	// --- System ---
	active: boolean("active").notNull().default(true),
	createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
	updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
	createdBy: uuid("created_by").references(() => users.id, { onDelete: "set null" }),
	updatedBy: uuid("updated_by").references(() => users.id, { onDelete: "set null" }),
})
